function notify(object, title, text, color, time = 3000) {
  object.notify({
    position: 'top-center',
    title,
    text,
    color,
    time,
  });
}

export default {
  notifySuccess(object, text, title = 'Atenção') {
    notify(object, title, text, 'success');
  },

  /**
   * Notificão com cor personalizada
   * @param {*} object this.$vs
   * @param {*} text texto a ser exibido
   * @param {*} title titulo da mensagem
   * @param {*} color cor personalizada
   */
  notifyCustonColor(object, text, title = 'Atenção', color = '#44C0F0') {
    notify(object, title, text, color);
  },

  /**
   * Notificação de Falha
   * @param {object} object this.$vs
   * @param {string} text texto a ser exibido
   * @param {string} title título da mensagem
   */
  notifyFail(object, text, title = 'Atenção') {
    notify(object, title, text, 'danger');
  },
};
